import filter from 'lodash/filter'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import CancellationPolicy from '../account/booking-details/CancellationPolicy'

const RESORT = 20
export default function PaymentSchedule({
  dueNowData,
  freeCancellationDays,
  shopKind,
}) {
  if(!dueNowData) {
    return null
  }
  const isKlarnaAvailable = useMemo(() => {
    return !window?.shop?.excludedPaymentMethods?.includes('klarna')
  })
  const paymentScheduleData = useMemo(() => {
    return {
      isCustomCancellation: dueNowData.shopData.isCustomCancellation,
      customCancellationText: dueNowData.shopData.customCancellationText,
      policy: dueNowData.shopData.cancellationPolicy,
      cancellationMilestones: dueNowData.shopData.cancellationMilestones,
      freeCancellationDays: freeCancellationDays,
      paymentTerms: dueNowData.shopData.paymentTerms,
      dueNow: filter(dueNowData.paymentMilestonesData, { isDueNow: true }),
      paymentSchedule: filter(dueNowData.paymentMilestonesData, {
        isDueNow: false,
      }),
      paymentMilestones: dueNowData.shopData.paymentMilestones,
      qty: 1,
      currency: dueNowData.currency,
    }
  }, [dueNowData, freeCancellationDays])

  const paymentMilestonesLength = get(
    paymentScheduleData,
    'paymentSchedule.length',
  )
  const dueNowAmount = get(paymentScheduleData, 'dueNow[0].amount')

  return (
    <div className='terms'>
      <p className='bold'>
        <FormattedMessage
          id='payment_schedule'
          defaultMessage='Payment schedule'
        />
      </p>
      <ul className='circled-list'>
        <li className='bold'>
          <FormattedMessage id='now_0' defaultMessage='Now: 0%' />
        </li>
        <li>
          <FormattedMessage
            id='checkout.payment_terms.downpayment'
            values={{
              amount: dueNowAmount,
              currency: paymentScheduleData.currency,
            }}
            defaultMessage='48 hours after booking confirmation {amount} {currency} (downpayment)'
          />
        </li>

        {paymentScheduleData.paymentSchedule.map((milestone, index) => {
          return (
            <li key={`${milestone.amount}${milestone.days}`}>
              {index + 1 !== paymentMilestonesLength ? (
                <FormattedMessage
                  id='checkout.milestone_amount_first'
                  values={{
                    amount: milestone.amount,
                    currency: paymentScheduleData.currency,
                    days: milestone.days,
                  }}
                  defaultMessage='{ days } days before trip start: { amount } { currency }'
                />
              ) : (
                <FormattedMessage
                  id='checkout.milestone_amount_last'
                  values={{
                    amount: milestone.amount,
                    currency: paymentScheduleData.currency,
                    days: milestone.days,
                  }}
                  defaultMessage='{ days } days before trip start: { amount } { currency } (balance)'
                />
              )}
            </li>
          )
        })}

        {shopKind === RESORT && isKlarnaAvailable && (
          <li>
            <FormattedMessage
              id='checkout.payment_terms.klarna'
              defaultMessage='Spread the cost with Klarna'
            />
          </li>
        )}
        <CancellationPolicy
          currency={paymentScheduleData.currency}
          isCustomCancellation={paymentScheduleData.isCustomCancellation}
          customCancellationText={paymentScheduleData.customCancellationText}
          freeCancellationDays={freeCancellationDays}
          milestones={paymentScheduleData.cancellationMilestones}
        />
      </ul>
    </div>
  )
}

PaymentSchedule.propTypes = {
  dueNowData: PropTypes.object,
  freeCancellationDays: PropTypes.number,
  shopKind: PropTypes.string,
  isKlarnaAvailable: PropTypes.bool,
}
